import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    // Redirect to landing page if there's no authenticated user
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;